import { render, staticRenderFns } from "./futureFeatures.vue?vue&type=template&id=2f0e6f74"
import script from "./futureFeatures.vue?vue&type=script&lang=js"
export * from "./futureFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports